export enum ApiEndpoints {
  ALERTS = '/alerts/',
  ALERTING_SETTINGS = '/alerting/settings/notifications/',
  ANALYST_NOTES = '/analyst_notes/',
  AUTH_USER = '/auth/',
  CALCULATORS = '/loss_calculator/',
  DOCS = '/docs/',
  DOCUMENTATION = '/documentation/',
  ENTITY_IDS = '/entity_ids/',
  MARKET_PRICES = '/market-prices/',
  MONITORING = '/monitoring/',
  RATINGS = '/ratings/',
  RISKS = '/risks/',
  USER = '/user',
  STABLECOIN = '/stablecoin/',
}

export enum ERoutes {
  DOCUMENTATION = '/documentation',
  FORGOT_PASSWORD = '/forgot-password',
  LOGIN = '/login',
  ONBOARDING = '/onboarding',
  RESET_PASSWORD = '/reset-password',
  MONITORING_ENTITY = '/monitoring/entity',
  MONITORING_SETTINGS = '/monitoring/settings',
  RATINGS = '/ratings',
  DASHBOARD = '/dashboard',
  DASHBOARD_SETTINGS = '/dashboard/settings',
  ENTITY = '/entity',
  RISK_SIMULATOR = '/risk-simulator',
  RISK_SIMULATOR_PORTFOLIO = '/risk-simulator/portfolio',
  STABLECOINS = '/stablecoins',
  SETTINGS = '/settings',
  ALERTING = '/alerting',
  ALERTING_SETTINGS = '/alerting/settings',
}

export enum ERatingTab {
  CUSTODIANS = 'custody',
  DEFI = 'defi',
  ETF = 'etf',
  EXCHANGES = 'cex',
  DATS = 'dat',
  LIQUIDITY_PROVIDERS = 'liquidity_provider',
  STABLECOINS = 'stablecoin_issuer',
}

export enum EEntityTab {
  RATING_DETAILS = 'rating-details',
  RISK_DRIVERS = 'risk-drivers',
  OCM = 'on-chain-data',
  MONITORING = 'monitoring',
  POR = 'proof-of-reserves',
  CORP_REGULATORY_PROF = 'corporate-regulatory-profile',
}

export enum EReservesMonitoringTab {
  OVERVIEW = 'overview',
  REPORTED_FIGURES = 'reported-figures',
  FINANCIAL_ESTIMATES = 'financial-estimates',
  ON_CHAIN_FLOWS = 'on-chain-flows',
  STRESS_TESTING = 'stress-testing',
  MARKET_PRICES = 'market-prices',
}
